import { memoize } from 'lodash';
import { getJson } from '@zapier/toolbox-browser-fetch';
import { TrackingMiddleware } from '../types';
import { isBrowser } from '../utils';

// Memoize this so that we don't fetch more than once
// (unless the baseUrl is different, which probably won't ever happen)
const getCurrentProfile = memoize(async (baseUrl: string) => {
  const url = `${baseUrl}/api/v3/profiles`;
  const cachedCurrentProfile = await getJson(url);
  return cachedCurrentProfile;
});

// Only exposed for testing purposes
export const clearCurrentProfileCache = () =>
  getCurrentProfile.cache.clear && getCurrentProfile.cache.clear();

const createMaybeAddUserAndIdentityId: TrackingMiddleware = config => {
  return async event => {
    // We don't want to be calling `/api/v3/profiles` from the server.
    if (!isBrowser()) {
      return;
    }

    let userId = event?.data?.userId;
    let identity_id = event?.data?.identity_id;
    if (!userId || !identity_id) {
      const { baseUrl = '' } = config.get(['service', 'baseUrl']);

      try {
        const cachedCurrentProfile = await getCurrentProfile(baseUrl);

        const { active_id, objects } = cachedCurrentProfile;

        if (!userId) {
          userId = active_id;
        }

        if (!identity_id) {
          identity_id = objects[0].identity;
        }
      } catch (e) {
        // ignore errors
      }
    }

    event.apply({
      userId,
      identity_id,
    });
    event._deprecatedSetProprtiesInRoot(['userId', 'identity_id']);
  };
};

export default createMaybeAddUserAndIdentityId;
